/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Button, Checkbox, DatePicker, message } from 'antd'
import { hasAccesPermits } from 'core/utils'

import {
  getApiTargetInfo,
  getStations,
  getUnits,
  getStationsNameMap,
  getPermitActions,
  getEnvConfig,
  timeZoneIdentMap,
} from 'core'
import * as ScreenPermissions from 'core/EventActions'
import { Content, CriteriaRow, FullHeightSizer, Title } from 'core/screen-util'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import { DatePickerContext, ErrorContext, SpinContext } from 'context'
import moment from 'moment'
import { getBkfSpillCause, getNonOutageSpill } from 'api/pgads'
import { freeEditEngine } from '@integec/grid-tools'
import SpillNonOutage from './SpillNonOutage'
import { BKFConversionFactorEffectiveByStation } from '../api/pgads'
const NonOutageSpill = ({
  targetInfo,
  // eslint-disable-next-line no-unused-vars
  stations,
  stationNameMap,
  units,
  envConfig,
  actionPermits,
}) => {
  const sortedStation = useMemo(
    _ => {
      // this is done bcoz all units under station if retired then not need to show that station
      const stat = R.compose(
        // R.map(station => ({ station, stationName: stationNameMap[station] })),
        R.map(([station, stationName]) => ({ station, stationName })),
        R.sortBy(R.prop(1)),
        R.map(station => [station, stationNameMap[station]]),
        R.uniq,
        R.map(u => u.station)
      )(units)

      return stat
    },
    [stationNameMap, units]
  )

  const { setError } = useContext(ErrorContext)
  const { setSpinning } = useContext(SpinContext)
  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)
  const [editInfo, setEditInfo] = useState(
    freeEditEngine.generateInitialEditInfo()
  )
  const [data, setData] = useState([])
  const [selStation, setSelStation] = useState([])
  const [isRetrieved, setIsRetrieved] = useState(false)
  const [spillCauseMap, setBkfSpillCauseMap] = useState({})
  useEffect(
    _ => {
      setData([])
      setEditInfo(freeEditEngine.generateInitialEditInfo())
      setIsRetrieved(false)
    },
    [selStation, selectedDate]
  )

  const stationZoneMap = useMemo(
    _ => {
      const stationZoneMap = R.compose(
        R.fromPairs,
        R.map(s => [s.station || '', s.timeZone])
        // R.filter(s => selStation.includes(s.station))
      )(units)
      return stationZoneMap
    },
    [units]
  )

  useEffect(
    _ => {
      getBkfSpillCause(targetInfo).fork(setError, spillType => {
        const spillMap = R.compose(
          R.fromPairs,
          R.map(s => [s.causeCode, s.displayString])
        )(spillType)

        setBkfSpillCauseMap(spillMap)
      })
    },
    [setError, targetInfo]
  )

  const changeStationSelecton = id => {
    if (selStation.includes(id)) {
      setSelStation(selStation.filter(s => s !== id))
    } else {
      setSelStation([...selStation, id])
    }
    setIsRetrieved(false)
  }

  // const selectAllSttations = _ => {
  //   setSelStation(R.map(s => s.station, sortedStation))
  //   setIsRetrieved(false)
  // }

  // const clearAllStation = _ => {
  //   setSelStation([])
  //   setIsRetrieved(false)
  // }

  const [factorList, setFactorList] = useState([])
  useEffect(
    _ => {
      if (selStation.length > 0) {
        BKFConversionFactorEffectiveByStation(targetInfo)(selStation).fork(
          _ => setFactorList([]),
          allFactor => {
            const sortedFactor = R.sort((a, b) => {
              return moment(a.effectiveDate).isSameOrAfter(
                moment(b.effectiveDate)
              )
                ? 0
                : 1
            }, allFactor)

            setFactorList(sortedFactor)
          }
        )
      } else setFactorList([])
    },
    [selStation, targetInfo]
  )

  const onRetrieve = _ => {
    if (selStation.length <= 0) return message.warning('Please, Select Station')
    setSpinning(true)
    getNonOutageSpill(targetInfo)({
      stationIds: selStation,
      year: selectedDate.format('YYYY'),
      month: selectedDate.format('MM'),
    }).fork(setError, data => {
      setSpinning(false)
      setIsRetrieved(true)
      setEditInfo(freeEditEngine.generateInitialEditInfo())
      const modifySpillData = spillData => {
        return spillData.map(d => {
          const eventStartZone = stationZoneMap[d.station]
          const spillStartMod =
            d.spillStart && eventStartZone
              ? moment
                  .utc(d.spillStart)
                  // .utc()
                  .tz(timeZoneIdentMap[eventStartZone])
                  .format('MM/DD/YYYY HH:mm')
              : // || moment(this.state.eventStart).format('MM/DD/YYYY HH:mm')
                undefined
          const spillEndMod =
            d.spillEnd && eventStartZone
              ? moment
                  .utc(d.spillEnd)
                  // .utc()
                  .tz(timeZoneIdentMap[eventStartZone])
                  .format('MM/DD/YYYY HH:mm')
              : // ||   moment(this.state.eventEnd).format('MM/DD/YYYY HH:mm')
                undefined

          return {
            ...d,
            spillStartMod,
            spillEndMod,
            // durHr,
            overwriteFactor: d.overwriteFactor || d.defaultFactor,
            action: 'N',
          }
        })
      }
      setData(modifySpillData(data || []))
    })
  }

  const isEditPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.NON_OUTAGE_SPILL_ADMIN],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  return (
    <div>
      <CriteriaRow
        css={{
          padding: '10px',
          display: 'grid',
          gridTemplateRows: 'max-content auto',
          gridTemplateColumns: '1fr',
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '200px 150px 200px 200px 200px',
            gap: '10px',
            marginBottom: '5px',
          }}
        >
          <Title>Non Outage Spill</Title>
          <DatePicker.MonthPicker
            format="MMMM-YYYY"
            style={{ width: '100%' }}
            value={selectedDate}
            onChange={date => setSelectedDate(date)}
            placeholder="Date"
          />
          <Button type="primary" onClick={onRetrieve} icon="database">
            Retrieve
          </Button>

          {/* <Button onClick={selectAllSttations} type="dashed">
            Select All
          </Button>
          <Button onClick={clearAllStation} type="dashed">
            Clear All
          </Button> */}
        </div>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
            alignContent: 'flex-start',
            height: '20vh',
            maxHeight: '20vh',
            overflow: 'auto',
            border: '1px solid #eee',
            borderRadius: '5px',
            padding: '10px',
            // paddingBottom: '10px',
          }}
        >
          {sortedStation.map(s => (
            <div
              key={s.station}
              style={{
                flex1: `0 0 100px`,
                width: '250px',
                overflow: 'hidden',
              }}
            >
              <Checkbox
                key={s.station}
                style={{ display: 'block' }}
                checked={selStation.includes(s.station)}
                // eslint-disable-next-line no-unused-vars
                onChange={checked => changeStationSelecton(s.station)}
              >
                {s.stationName}-{s.station}
              </Checkbox>
            </div>
          ))}
        </div>
      </CriteriaRow>

      <FullHeightSizer heightOffset={370}>
        {({ height, width }) => (
          <Content style={{ height, paddingTop: '5px' }}>
            <SpillNonOutage
              isEditPermission={isEditPermission}
              isRetrieved={isRetrieved}
              retrieveData={onRetrieve}
              year={selectedDate.format('YYYY')}
              month={selectedDate.format('MM')}
              stationNameMap={stationNameMap}
              editInfo={editInfo}
              setEditInfo={setEditInfo}
              stationZoneMap={stationZoneMap}
              factorList={factorList}
              data={data}
              height={height - 120}
              width={width - 100}
              spillCauseMap={spillCauseMap}
              selectedStation={selStation}
              eventStart={selectedDate
                .clone()
                .date(1)
                .hour(0)
                .minute(0)
                .second(0)
                .format('YYYY-MM-DDTHH:mm:ss')}
              eventEnd={selectedDate
                .clone()
                .date(1)
                .hour(0)
                .minute(0)
                .second(0)
                .add(1, 'M')
                // .subtract('1', 'd')
                .format('YYYY-MM-DDTHH:mm:ss')}
            />
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  stations: getStations(state),
  stationNameMap: getStationsNameMap(state),
  units: getUnits(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
})

export default connect(mapStateToProps)(NonOutageSpill)
